import "lib/@hooks/useEvent"
import { useState } from "react"
import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { ScheduleCodeAvailabilityChanged } from "../schedule-editor-event-definitions.mjs"

/**
 * Returns true while `ScheduleCodeEditableField`'s live check has found the current code
 * colliding with another schedule (or is still checking) — used to gate Submit for Review.
 *
 * @returns {boolean}
 */
export function useScheduleCodeUnavailable() {
    const { draftId } = useScheduleEditorIds()
    const [unavailable, setUnavailable] = useState(false)

    ScheduleCodeAvailabilityChanged(draftId).useEvent(handleAvailabilityChanged)

    return unavailable

    function handleAvailabilityChanged(payload) {
        setUnavailable(Boolean(payload?.unavailable))
    }
}
